<template>
    <div id="media-vault-modal" class="media-vault-modal modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg d-flex media-vault-modal-animation-hide" role="document">
            <div class="modal-content my-auto">
                <div class="modal-header border-bottom">
                    <h5 class="modal-title my-auto">Add Media</h5>
                    <CloseButton @click="onCancel"/>
                </div>
                <div class="modal-header border-bottom p-0">
                    <div class="nav-scroller border-bottom w-100">
                        <div class="nav nav-tabs">
                            <a @click="currentTab = 'media-vault'" href="javascript:void(0);" class="nav-link w-100" :class="{ 'active': currentTab === 'media-vault'}">
                                <i class="far fa-lock-alt"></i> Media Vault
                            </a>
                            <a @click="currentTab = 'media-uploader'" href="javascript:void(0);" class="nav-link w-100" :class="{ 'active': currentTab === 'media-uploader'}">
                                <i class="far fa-upload"></i> Upload Content
                            </a>
                        </div>
                    </div>
                </div>
                <div class="modal-body p-0 bg-light">
                    <div>
                        <div style="height:60vh;overflow-y:scroll;">

                            <MediaVault ref="media-vault"
                                v-show="currentTab === 'media-vault'"
                                @selected-media-changed="onSelectedMediaChanged($event)"
                                :show-click-mode="true"
                                :hide-media-info-sidebar="true"
                                :hide-selection-toolbar="true"
                                :without-toolbar-top-offset="true"/>

                            <MediaUploader ref="media-uploader"
                                v-show="currentTab === 'media-uploader'"
                                :hide-save-button="true"
                                @selected-file-changed="selectedFile = $event"/>

                        </div>
                    </div>
                </div>
                <div v-show="currentTab === 'media-vault'" class="modal-footer">
                    <button @click="onCancel" type="button" class="btn btn-secondary w-100">Cancel</button>
                    <button @click="onDone" type="button" class="btn btn-primary w-100" :disabled="selectedMediaCount === 0">
                        <span>Add Selected</span>
                        <span v-if="selectedMediaCount > 0">({{ selectedMediaCount }})</span>
                    </button>
                </div>
                <div v-show="currentTab === 'media-uploader'" class="modal-footer">
                    <button @click="onCancel" type="button" class="btn btn-secondary w-100">Cancel</button>
                    <button @click="onAddToPost" type="button" class="btn btn-primary w-100" :disabled="!canAddToPost()">
                        <span>Add</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* add safe area margin to modal footer */
.media-vault-modal .modal-content .modal-footer {
    margin-bottom: env(safe-area-inset-bottom);
}

/* remove safe area margin from bottom of modal so we can show the white of modal off screen */
.media-vault-modal .modal-dialog {
    padding-bottom: 0 !important;
}
</style>

<script>
import MediaVault from "./MediaVault";
import MediaUploader from "./MediaUploader";
import CloseButton from "../Modals/CloseButton";
export default {
    name: 'Picker',
    components: {
        CloseButton,
        MediaUploader,
        MediaVault
    },
    data: function() {
        return {
            modal: null,
            currentTab: 'media-vault',
            mediaVault: null,
            mediaUploader: null,
            selectedFile: null,
            selectedMediaCount: 0,
        };
    },
    mounted() {

        // find modal element
        this.modal = $('#media-vault-modal');

        // find componenets
        this.mediaVault = this.$refs["media-vault"];
        this.mediaUploader = this.$refs["media-uploader"];

        // listen for modal showing event
        this.modal.on('show.bs.modal', (e) => {
            this.modal.removeClass('media-vault-modal-animation-hide');
            this.modal.addClass('media-vault-modal-animation-show');
        });

        // listen for modal hiding event
        this.modal.on('hide.bs.modal', (e) => {
            if(this.modal.hasClass('show') && this.modal.hasClass('media-vault-modal-animation-show')){

                // prevent hiding modal
                e.preventDefault();

                // remove show class so animation is reversed
                this.modal.removeClass('media-vault-modal-animation-show');
                this.modal.addClass('media-vault-modal-animation-hide');

                // hide modal after animation has finished
                setTimeout(() => {
                    this.modal.modal('hide');
                }, 300);

            }
        });

    },
    methods: {
        canAddToPost: function() {
            return this.selectedFile != null
                && this.selectedFile.status === 'completed'; // file must be uploaded
        },
        show: function(tab) {

            if(tab){
                this.currentTab = tab;
            }

            this.mediaVault.reload();
            this.mediaVault.startSelectionMode();

            this.mediaUploader.onShow();

            this.modal.modal('show');

        },
        hide: function() {
            this.selectedMediaCount = 0;
            this.mediaVault.stopSelectionMode();
            this.modal.modal('hide');
        },
        onCancel: function() {
            this.hide();
        },
        onDone: function() {
            let selectedMediaIds = this.mediaVault.selectedMediaIds;
            this.$emit('media-picked', selectedMediaIds);
            this.hide();
        },
        onAddToPost: function() {

            // add selected file to post and remove it from ui
            if(this.selectedFile && this.selectedFile.status === 'completed'){

                this.$emit('media-picked', [this.selectedFile.media_id]);
                this.mediaUploader.saveSelectedFile();

                // tell user media is added to post
                window.toastr.info('Media Added!', null, {
                    timeOut: 2000,
                    positionClass: 'toast-top-right',
                });

            }

            // dismiss modal if no more files
            if(this.mediaUploader.files.length === 0){
                this.hide();
            }

        },
        onSelectedMediaChanged: function(selectedMediaIds) {
            this.selectedMediaCount = selectedMediaIds.length;
        },
    },
}
</script>
